import Form from './Form';

const Components = {
    Form : Form
}

export default Components;